import styled from 'styled-components';
import Typography from '@mui/material/Typography';

const StyledAlertText = styled(Typography)`
	word-break: break-word;
	overflow-wrap: break-word;
`;

export default StyledAlertText;
